var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"productview-cont"},[_c('div',{staticClass:"sm-mainwrap"},[_c('VueProductSpinner',{attrs:{"images":_vm.imgs,"infinite":true,"slider":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }